import { gql } from "@apollo/client"

export const GET_STAFF_ID_BY_MEMBERSHIP_ID = gql`
  query GetStaffMembership($staff_membership_id: ID!) {
    staffDataByStaffMembershipID(staff_membership_id: $staff_membership_id) {
      staff_id
      rol_id
      organization_id
      staff_name_first
      staff_name_last
    }
  }
`

export const GET_USER = gql`
  query getStaff($staff_id: ID!, $organization_id: ID) {
    user(staff_id: $staff_id, organization_id: $organization_id) {
      staff_id
      staff_alias
      staff_user_status
      staff_name_first
      staff_name_last
      staff_role
      staff_role_name
      staff_description
      staff_group_type
      staff_email_address
      staff_create_date
      staff_membership_id
      environment
      enterprise_id
      enterprise_alias
      enterprise_id_stamp
      enterprise_name
      enterprise_type
      organization_id
      organization_alias
      organization_name
      organization_type
      staff_primary_supervisor_name
      staff_hire_date
      staff_phone_number
      staff_phone_telerecovery
      staff_last_login
      staff_id_stamp
    }
  }
`

export const GET_STAFF_PROFILE = gql`
  query getStaffMembershipProfile($staff_id_stamp: ID!) {
    getStaffMembershipProfile(staff_id_stamp: $staff_id_stamp) {
      blocks {
        block_title
        block_name
        total_fields
        index
      }
    }
  }
`

export const GET_STAFF_PROFILE_BOX = gql`
  query getStaffProfileBox($staff_id: ID!, $organization_id: ID!) {
    getStaffProfileBox(staff_id: $staff_id, organization_id: $organization_id) {
      staff_name_first
      staff_name_last
      staff_phone_number
      staff_profile_image
      staff_phone_telerecovery
      staff_primary_supervisor_name
      staff_hire_date
      assigned_participants
      staff_last_login
      staff_role_name
      staff_last_supervision_date
      staff_primary_supervisor
      staff_id_stamp
    }
  }
`

export const STAFF_BLOCK = gql`
  query ParticipantBlock(
    $participant_id: ID!
    $idBlock: ID!
    $type: ID
    $organization_id: ID
    $enterprise_id: ID
  ) {
    block(
      idBlock: $idBlock
      type: $type
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      fields {
        idField
        field_type
        field_description
        field_conditional
        field_label
        field_name
        field_visibility
        field_options {
          ...fieldOptions
          __typename
        }
        field_validation {
          ...fieldValidation
          __typename
        }
        multi_fields {
          ...multiField
          multi_fields {
            ...multiField
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    blockSaved(
      participant_id: $participant_id
      block_name: $idBlock
      organization_id: $organization_id
    ) {
      data
      __typename
    }
  }

  fragment fieldOptions on TypeFieldOptions {
    label
    value
    __typename
  }

  fragment fieldValidation on TypeFieldValidation {
    required
    min
    max
    maxlength
    file_extension
    file_size
    file_multi_files
    file_firestore_storage
    file_cloud_storage
    file_is_shared
    file_is_renameable
    __typename
  }

  fragment multiField on TypeMultiField {
    field_name
    field_type
    field_label
    field_options {
      ...fieldOptions
      __typename
    }
    field_validation {
      ...fieldValidation
      __typename
    }
    __typename
  }
`

export const GET_STAFF_PROFILE_TABLE = gql`
  query StaffProfileTable(
    $staff_id: ID!
    $organization_id: ID
    $enterprise_id: ID
    $participant_id: ID!
    $idTemplate: ID!
    $type: ID!
    $idStamp: ID
  ) {
    template(
      staff_id: $staff_id
      participant_id: $participant_id
      idTemplate: $idTemplate
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      type: $type
      idStamp: $idStamp
    ) {
      template_title
      template_description
      blocks {
        idBlock
        block_name
        block_title
        total_fields
        index
        fields {
          field_name
          field_label
          field_type
          description
          field_description
          multi_fields {
            field_name
            field_type
            field_label
            multi_fields {
              field_name
              field_type
              field_label
            }
          }
          field_options {
            label
            value
          }
        }
      }
      values
    }
  }
`

export const GET_BLOCKS_SAVED = gql`
  query BlocksSaved($idStamp: ID!) {
    getBlockSavedByIdStamp(idStamp: $idStamp) {
      data
    }
  }
`

export const GET_SAVED_TEMPLATE_BY_SELECTED_STAFF = gql`
  query TemplateSavedByStaffIdSelector(
    $supervision_staff_membership_id: ID!
    $organization_id: ID!
    $idTemplate: String!
  ) {
    blocksSavedByStaffAndOrg(
      supervision_staff_membership_id: $supervision_staff_membership_id
      organization_id: $organization_id
      idTemplate: $idTemplate
    ) {
      data
    }
  }
`
export const GET_CUSTOM_FIELD = gql`
  query GetCustomField($idField: ID!, $type: ID!) {
    fieldByName(idField: $idField, type: $type) {
      idField
      field_name
      field_name_report
      description
      field_label
      field_description
      field_label_name
      field_type
      field_options {
        label
        value
      }
      field_validation {
        required
        number_min
        number_max
      }
      field_conditional
    }
  }
`

export const GET_STAFF_NAME = gql`
  query getStaffName($staff_id: ID!, $organization_id: ID!) {
    getStaffName(staff_id: $staff_id, organization_id: $organization_id) {
      data
    }
  }
`
export const GROUP_SUPERVISION_SESSIONS = gql`
  query GroupSupervisionSessions(
    $organization_id: ID
    $idTemplate: ID!
    $staff_id: ID
  ) {
    groupSupervisionSessions: getAllGroupSessionsStaff(
      organization_id: $organization_id
      idTemplate: $idTemplate
      groupByIdStamp: true
      staff_id: $staff_id
    ) {
      data
    }
  }
`

export const STAFF_SUPERVISION_GROUP_BY_TEMPLATE = gql`
  query StaffSupervision(
    $staff_membership_id: ID!
    $organization_id: ID!
    $idTemplate: String!
    $idBlocks: [ID]
  ) {
    staffSupervision: getStaffSupervisionBlocksGroupByIdTemplate(
      staff_membership_id: $staff_membership_id
      organization_id: $organization_id
      idTemplate: $idTemplate
      idBlocks: $idBlocks
      groupByIdStamp: true
    ) {
      data
    }
  }
`
